var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.36,15l1.35-1.34L18,12.9V7.1l-.29-.71-4.1-4.1L12.9,2H7.1l-.71.29-4.1,4.1L2,7.1v5.8l.29.71,4.1,4.1L7.1,18h5.8l.71-.29L15,16.36l5.34,5.35,1.42-1.42ZM16,12.49,12.49,16h-5L4,12.49v-5L7.51,4h5L16,7.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/1765983986/media/icon-search.e46bcc5ea59764906ea49b545a90a497.svg";
export { ForwardRef as ReactComponent };